import axios from '@/plugins/axios';

/**
 * Upozornenia v aplikácii (zvonček, karta „Upozornenia“ na Prehľade) - len vlastné upozornenia prihláseného
 * používateľa. Označovanie ako prečítané vracia aj aktuálny počet neprečítaných (`neprecitane`).
 */
class NotifikacieService {
  /**
   * Zoznam upozornení (neprečítané najprv, potom podľa poslednej udalosti)
   * @param {Object} [params] - { limit = 20 (najviac 100), neprecitane: 1 = len neprečítané }
   * @returns {Promise} { success, data: [{ id, typ, titulok, text, odkaz, objekt_typ, objekt_id, pocet, precitane, vytvorene, aktualizovane, autor }], neprecitane }
   */
  zoznam(params = {}) {
    return axios.get('/notifikacie', { params });
  }

  /** Počet neprečítaných upozornení → { success, count } */
  pocet() {
    return axios.get('/notifikacie/pocet');
  }

  /** Označenie upozornenia ako prečítaného → { success, neprecitane } */
  precitat(id) {
    return axios.patch(`/notifikacie/${id}/precitane`);
  }

  /** Označenie všetkých upozornení ako prečítaných → { success, updated, neprecitane } */
  precitatVsetko() {
    return axios.post('/notifikacie/precitat-vsetko');
  }

  /**
   * Prečítané všetky upozornenia k záznamu (otvorenie detailu) → { success, updated, neprecitane }
   * @param {'uloha'|'poziadavka'|'prikaz'|'podnet'} objekt_typ
   * @param {number} objekt_id
   */
  precitatObjekt(objekt_typ, objekt_id) {
    return axios.post('/notifikacie/precitat-objekt', { objekt_typ, objekt_id });
  }
}

export default new NotifikacieService();
